import axios from 'axios';
import { PrivateAxios } from '../api';

const API_URL = 'https://service.samoolah.com/public';
const STATIC_TOKEN = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjo0NywidXNlcl90eXBlIjoidXNlciJ9.YRJLq7-by5QCbsUgUuafUFRSutnHWNVP-e1UPttlEPo';

// For unauthenticated requests, you can use a standard axios instance
const register = (userData) => {
  const formData = new FormData();
  Object.keys(userData).forEach((key) => {
    formData.append(key, userData[key]);
  });
  return axios.post(`${API_URL}/api/user/register`, formData);
};

const login = (userData) => {
  return axios.post(`${API_URL}/login`, userData);
};

// For authenticated requests, use the PrivateAxios instance with the token in headers
const createProfile = (userData) => {
  return PrivateAxios.post(`${API_URL}/updateprofile`, userData, {
    headers: {
      Authorization: `Bearer ${STATIC_TOKEN}`,
    },
  });
};

const resetPassword = (userData) => {
  return PrivateAxios.post(`${API_URL}/restpassword`, userData, {
    headers: {
      Authorization: `Bearer ${STATIC_TOKEN}`,
    },
  });
};

const authAPI = {
  register,
  login,
  createProfile,
  resetPassword,
};

export default authAPI;